import React from "react";
import Routes from "./routes";
 
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.css";
import "./App.css";


const App = () => <Routes />;
export default App;